import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d3a1363"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid pulse-inbox-contents h-screen" }
const _hoisted_2 = {
  id: "header",
  class: "border-bottom"
}
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = { class: "w-100 items-center flex flex-grow email-search" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = {
  key: 0,
  class: "dropdown-content",
  style: {"position":"absolute"}
}
const _hoisted_7 = { class: "pl-2" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "pl-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pl-2",
  for: "allFoldersCheckbox"
}, " Search all folders ", -1))
const _hoisted_12 = { class: "pr-2" }
const _hoisted_13 = {
  key: 0,
  class: "text-lg md:font-bold"
}
const _hoisted_14 = {
  key: 1,
  class: ""
}
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " From: ", -1))
const _hoisted_17 = { class: "font-bold pl-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pl-1" }, " - ", -1))
const _hoisted_19 = {
  key: 0,
  class: "italic font-bold pl-1"
}
const _hoisted_20 = {
  key: 1,
  class: "pl-1"
}
const _hoisted_21 = {
  key: 2,
  class: "font-bold pl-1"
}
const _hoisted_22 = {
  key: 0,
  class: "flex justify-content-start pl-3"
}
const _hoisted_23 = { class: "pl-1 pb-2" }
const _hoisted_24 = { class: "flex flex-row items-center" }
const _hoisted_25 = {
  key: 0,
  class: "text-xs font-semibold pl-1"
}
const _hoisted_26 = {
  key: 1,
  class: "pl-1 text-sm"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 2,
  class: "text-xs font-semibold pl-1"
}
const _hoisted_29 = {
  key: 3,
  class: "pl-1 text-sm"
}
const _hoisted_30 = {
  id: "menu",
  class: "w-100"
}
const _hoisted_31 = { class: "col-12 bg-gray px-0 h-full" }
const _hoisted_32 = { class: "flex align-items-center h-full" }
const _hoisted_33 = { class: "flex pl-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow pl-2 pt-2" }, [
  /*#__PURE__*/_createElementVNode("label", null, " Select All ")
], -1))
const _hoisted_35 = { class: "flex justify-between" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  id: "content",
  class: "expanded border-bottom overflow-auto"
}
const _hoisted_41 = { style: {"width":"100%"} }
const _hoisted_42 = {
  key: 0,
  class: "grid grid-cols-3 place-content-center bg-primary h-10 px-2"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 justify-self-end",
  style: {"color":"white"}
}, " Search Results... ", -1))
const _hoisted_44 = { class: "" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 2,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_48 = { key: 3 }
const _hoisted_49 = {
  id: "footer",
  class: "items-center justify-center flex p-2"
}
const _hoisted_50 = { class: "flex items-center justify-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1))
const _hoisted_54 = [
  _hoisted_51,
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  class: "modal fade",
  id: "moveToFolderModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "moveToFolderModalLabel",
  "aria-hidden": "true"
}
const _hoisted_56 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "moveToFolderModalLabel"
  }, " Move to folder "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_59 = { class: "modal-body" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Move to folder...", -1))
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "modal-footer" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary px-5",
  "data-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_64 = {
  class: "modal fade",
  id: "markAsReadModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "markAsReadModalLabel",
  "aria-hidden": "true"
}
const _hoisted_65 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = {
  class: "modal-title",
  id: "markAsReadModalLabel"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1))
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { class: "modal-footer" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary px-5",
  "data-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_73 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_74 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_75 = { class: "modal-content" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "moveToFolderModalLabel"
  }, " Delete Email "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_77 = { class: "modal-body" }
const _hoisted_78 = { class: "modal-footer" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary px-5",
  "data-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_80 = {
  class: "modal fade",
  id: "junkModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "junkModalLabel",
  "aria-hidden": "true"
}
const _hoisted_81 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_82 = { class: "modal-content" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "junkModalLabel"
  }, "Send Email to Junk"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to send the selected to Junk")
  ])
], -1))
const _hoisted_85 = { class: "modal-footer" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary px-5",
  "data-dismiss": "modal"
}, " Cancel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_CustomMenuItem = _resolveComponent("CustomMenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_EmailListItem = _resolveComponent("EmailListItem")!
  const _component_VPagination = _resolveComponent("VPagination")!
  const _component_vue_resizable = _resolveComponent("vue-resizable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_vue_resizable, { class: "resizable-content" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "email-search-icon text-secondary",
                    icon: ['fas', 'search']
                  }),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "search-box bg-gray w-100",
                    autocomplete: "off",
                    placeholder: " Search",
                    ref: "search",
                    id: "search",
                    onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDropdown(true))),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDropdown(false))),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDropdown(true))),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                    onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchEmails && _ctx.searchEmails(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.search]
                  ]),
                  (_ctx.dropdownOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("a", {
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.addSearchTerm('From:')), ["prevent"]))
                        }, "From:"),
                        _createElementVNode("a", {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.addSearchTerm('To:')), ["prevent"]))
                        }, "To:"),
                        _createElementVNode("a", {
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.addSearchTerm('Subject:')), ["prevent"]))
                        }, "Subject:")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "cursor-pointer hover:bg-gray-400",
                    title: "Clear Search",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearSearchText && _ctx.clearSearchText(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "text-secondary",
                      icon: ['fas', 'times-circle']
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.allFolders) = $event)),
                  id: "allFoldersCheckbox",
                  type: "checkbox",
                  disabled: _ctx.search.length == 0,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('updateSearchFolder', this.searchView, !this.allFolders)))
                }, null, 8, _hoisted_10), [
                  [_vModelCheckbox, _ctx.allFolders]
                ]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.date) = $event)),
                  range: "",
                  multiCalendars: "",
                  enableTimePicker: false,
                  onClosed: _ctx.searchEmails
                }, {
                  "action-preview": _withCtx(({ value }) => [
                    (value == null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Select a From and To date "))
                      : _createCommentVNode("", true),
                    (value != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDate(value[0])), 1),
                            _hoisted_18,
                            (!value[1])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Select a To date "))
                              : _createCommentVNode("", true),
                            (value[1])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " To: "))
                              : _createCommentVNode("", true),
                            (value[1])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.formatDate(value[1])), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  trigger: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      class: "text-secondary cursor-pointer",
                      icon: ['fas', 'calendar']
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onClosed"])
              ])
            ]),
            (_ctx.date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "text-secondary cursor-pointer",
                      icon: ['fas', 'times-circle'],
                      onClick: _withModifiers(_ctx.clearSearchDates, ["prevent"])
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.date[0])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, " From: "))
                        : _createCommentVNode("", true),
                      (_ctx.date[0])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.date[0] )) + " ", 1),
                            (_ctx.date[1])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " - "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.date[1])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, " To: "))
                        : _createCommentVNode("", true),
                      (_ctx.date[1])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.date[1] )), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectAll) = $event)),
                      id: "selectAll"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.selectAll]
                    ])
                  ]),
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "btn btn-text no-focus px-2",
                      "data-toggle": "modal",
                      "data-target": "#moveToFolderModal",
                      onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFolderModal && _ctx.toggleFolderModal(...args)), ["prevent"])),
                      disabled: _ctx.bulkSelected.length === 0
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: _normalizeClass(["text-secondary", _ctx.bulkSelected.length === 0 && 'disabled']),
                        icon: ['fas', 'folder-open'],
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: "Move to folder..."
                      }, null, 8, ["class"])
                    ], 8, _hoisted_36),
                    _createElementVNode("button", {
                      class: "btn btn-text no-focus px-2",
                      "data-toggle": "modal",
                      "data-target": "#markAsReadModal",
                      disabled: _ctx.bulkSelected.length === 0
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: _normalizeClass(["text-secondary", _ctx.bulkSelected.length === 0 && 'disabled']),
                        icon: 
                      _ctx.isAllSelectedUnread
                        ? ['fas', 'envelope-open']
                        : ['fas', 'envelope']
                    ,
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: 
                      _ctx.isAllSelectedUnread ? 'Mark as Read' : 'Mark as Unread'
                      }, null, 8, ["class", "icon", "title"])
                    ], 8, _hoisted_37),
                    _createElementVNode("button", {
                      class: "btn btn-text no-focus px-2",
                      "data-toggle": "modal",
                      "data-target": "#deleteModal",
                      disabled: _ctx.isDeleteEmailDisabled
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: _normalizeClass(["text-secondary", _ctx.isDeleteEmailDisabled && 'disabled']),
                        icon: ['fas', 'trash-alt'],
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: "Delete selected emails"
                      }, null, 8, ["class"])
                    ], 8, _hoisted_38),
                    _createElementVNode("button", {
                      class: "btn btn-text no-focus px-2",
                      "data-toggle": "modal",
                      "data-target": "#junkModal",
                      disabled: _ctx.bulkSelected.length === 0
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: _normalizeClass(["text-secondary", _ctx.bulkSelected.length === 0 && 'disabled']),
                        icon: ['fas', 'ban'],
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: "Mark as junk"
                      }, null, 8, ["class"])
                    ], 8, _hoisted_39),
                    _createVNode(_component_Menu, {
                      as: "div",
                      class: "flex flex-grow-1 align-items-center px-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuButton, { class: "bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              class: "text-secondary",
                              icon: ['fas', 'sort'],
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              title: "Sort"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_Transition, {
                          "enter-active-class": "transition ease-out duration-100",
                          "enter-from-class": "transform opacity-0 scale-95",
                          "enter-to-class": "transform opacity-100 scale-100",
                          "leave-active-class": "transition ease-in duration-75",
                          "leave-from-class": "transform opacity-100 scale-100",
                          "leave-to-class": "transform opacity-0 scale-95"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MenuItems, { class: "absolute right-0 mt-56 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortByMenuItems, (sortByMenuItem) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "flex flex-col justify-start text-sm",
                                    key: sortByMenuItem.name
                                  }, [
                                    _createVNode(_component_CustomMenuItem, {
                                      "button-name": sortByMenuItem.name,
                                      "is-selected": _ctx.selectedSortBy == sortByMenuItem,
                                      "sort-is-descending": _ctx.sortIsDescending,
                                      "icon-type": _ctx.selectedSortBy.name == 'Default' || _ctx.selectedSortBy != sortByMenuItem ? null : !_ctx.sortIsDescending ? 'arrow-up' : 'arrow-down',
                                      onSelected: e => _ctx.setSortingArrow(e, sortByMenuItem)
                                    }, null, 8, ["button-name", "is-selected", "sort-is-descending", "icon-type", "onSelected"])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              (_ctx.searchView && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", {
                      class: "justify-self-end cursor-pointer text-xs pt-1",
                      style: {"color":"white"},
                      onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearAllSearchFilters && _ctx.clearAllSearchFilters(...args)), ["prevent"]))
                    }, " Clear ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_44, [
                (_ctx.error != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                (_ctx.error == '' && !_ctx.loading && _ctx.emails.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, " This folder is empty! "))
                  : _createCommentVNode("", true),
                (_ctx.loading || _ctx.error.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-primary",
                        icon: ['fas', 'spinner'],
                        size: "lg",
                        spin: ""
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && _ctx.emails.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (eml) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: eml.id
                        }, [
                          _createVNode(_component_EmailListItem, {
                            email: eml,
                            selected: eml.id == (_ctx.email || { id: '' }).id,
                            onClicked: _ctx.handleClick,
                            isBulkSelected: _ctx.bulkSelected.some((x) => x.id === eml.id),
                            onBulkSelected: _ctx.handleBulkSelect
                          }, null, 8, ["email", "selected", "onClicked", "isBulkSelected", "onBulkSelected"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_VPagination, {
                pagination: _ctx.emailsPagination,
                "onUpdate:pagination": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.emailsPagination) = $event)),
                onPageChanged: _cache[16] || (_cache[16] = (page) => (_ctx.currentPage = page))
              }, null, 8, ["pagination"]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.listConfig.paginationInformation.itemsPerPage) = $event)),
                onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.setResultsPerPage && _ctx.setResultsPerPage(...args))),
                style: {"margin-left":"10px","padding":"3px","padding-bottom":"3px"}
              }, _hoisted_54, 544), [
                [_vModelSelect, _ctx.listConfig.paginationInformation.itemsPerPage]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bulkTargetFolderId) = $event)),
                  class: "custom-select no-focus w-100"
                }, [
                  _hoisted_60,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders.folders, (fld) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: fld.id,
                      key: fld.id
                    }, _toDisplayString(fld.name), 9, _hoisted_61))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.bulkTargetFolderId]
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-dismiss": "modal",
                  onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.moveToFolderMultiple()), ["prevent"]))
                }, " Move ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("h5", _hoisted_68, _toDisplayString(_ctx.bulkSelected.every((x) => x.isReadBySelf === false)
                  ? "Mark selected as Read"
                  : "Mark selected as Unread"), 1),
                _hoisted_69
              ]),
              _createElementVNode("div", _hoisted_70, " Are you sure you want to mark the selected as " + _toDisplayString(_ctx.bulkSelected.every((x) => x.isReadBySelf === false)
                ? "read"
                : "unread") + "? ", 1),
              _createElementVNode("div", _hoisted_71, [
                _hoisted_72,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-dismiss": "modal",
                  onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.massChangeReadStatus()), ["prevent"]))
                }, " Confirm ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, " Are you sure you want to delete " + _toDisplayString(_ctx.bulkSelected.length) + " email(s)? ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-dismiss": "modal",
                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.deleteEmails()), ["prevent"]))
                }, " Delete ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _hoisted_83,
              _hoisted_84,
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  "data-dismiss": "modal",
                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.sendToJunk()), ["prevent"]))
                }, " Confirm ")
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}